import * as api from 'app/shared/api';
import { Dispatch } from 'redux';
import { Action } from 'app/pages/Products/actionTypes';
import { pageLoaded } from '../Products/actions';
import { AccommodationTypeValue, CourseIntensityDto, ProductDivision, TransferPort, TransferType, UnitType , ProductCategory, AccountCategory, Languages} from 'app/shared/model';

type ProductsData = {
    courseIntensity: CourseIntensityDto[],
    productDivisions: ProductDivision[],
    accommodationTypes:AccommodationTypeValue[],
    unitTypes:UnitType[],
    transferTypes:TransferType[],
    transferPorts:TransferPort[],
    productCategories: ProductCategory[],
    accountCategories: AccountCategory[],
    languages: Languages[]
}

export function loadPage(dispatch: Dispatch<Action>) : Promise<void> {
    return fetchServerData()
    .then(x => {
        dispatch(pageLoaded(x.courseIntensity,x.productDivisions,x.accommodationTypes,x.unitTypes,x.transferTypes,x.transferPorts,x.productCategories,x.accountCategories,x.languages));
    });
}

function fetchServerData() : Promise<ProductsData> {
    
    const courseIntensityList = api.getCourseIntensities(); 
    const productDivisionList = api.getAllProductDivisions();
    const accommodationTypeList = api.getAllAccommodationTypes();
    const unitTypesList = api.getAllUnitTypes();
    const transferTypesList = api.getAllTransferTypes();
    const transferPortsList = api.getAllTransferPorts();
    const productCategoriesList = api.getAllProductCategories();
    const accountCategoriesList = api.getAllAccountCategories();
    const languagesList = api.getAllLanguages();

    return Promise.all([courseIntensityList,productDivisionList,accommodationTypeList,unitTypesList,transferTypesList,transferPortsList,productCategoriesList,accountCategoriesList,languagesList])    
    .then(serverData => {
        const courseIntensity = serverData[0];
        const productDivisions = serverData[1];
        const accommodationTypes = serverData[2];
        const unitTypes = serverData[3];
        const transferTypes = serverData[4];
        const transferPorts = serverData[5];
        const productCategories = serverData[6];
        const accountCategories = serverData[7];
        const languages = serverData[8];

        return {courseIntensity,productDivisions,accommodationTypes,unitTypes,transferPorts,transferTypes,productCategories,accountCategories,languages};
    });
}